import React, { useEffect, useState } from 'react';
import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonList, IonPage, IonProgressBar, IonRange, IonRouterLink, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import { chatbubble, checkmarkCircleOutline } from 'ionicons/icons';
import { informationCircle, videocamOutline, bookOutline, helpOutline } from 'ionicons/icons';



const Infos: React.FC = () => {

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle><IonImg src="logo_lichteMomente.png" style={{ maxHeight: '5vh', height: "5vh" }} />Infos zum Kurs  </IonTitle>

        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large"><IonImg src="logo_lichteMomente.png" style={{ maxHeight: '10vh', height: "10vh" }} />Infos zum Kurs </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonCard>
          <IonCardContent>
          <p>
       In diesem Kurs geht es um den Umgang mit Menschen mit Demenz und um die Menschen, die sie täglich oder auch nur gelegentlich begleiten:
 <br /><br />
•	Ehepartner, Söhne und Töchter, Enkelkinder,<br />
•	Engagierte im Besuchsdienst in Krankenhäusern und Pflegeeinrichtungen,<br />
•	Nachbarinnen und Freunde von Menschen mit Demenz<br />
<br /><br />
Wir wollen Sie mitnehmen auf eine Entdeckungsreise in die Lebenswelt von Menschen, die nach unseren Maßstäben die Orientierung verloren haben. Dementielle Erkrankungen beeinträchtigen das gegenseitige Verstehen zutiefst. Sie rufen Unsicherheit, Ohnmachtsgefühle und auch Ärger hervor. Wenn Sie selbst mit diesen Gefühlen und Haltungen besser umgehen wollen, dann sind bei uns richtig.<br /><br />

Die Begegnung mit Menschen mit Demenz wird von vielen als schwierig empfunden, da die kognitiven und sprachliche Beeinträchtigungen eine große Hürde für den Kontakt mit ihnen darstellen. In diesem Kurs stellen wir aber nicht die Defizite in den Vordergrund, sondern die Person.<br /><br />

Unser Bezugsrahmen sollte nicht länger die Person mit DEMENZ, sondern die PERSON mit Demenz sein, schreibt der Psychologe Tom Kitwood).<br /><br />

Und so sind die einzelnen Module aufgebaut:<br /><br />

•	Ausgangspunkt für jedes Modul ist ein Fallbeispiel aus der Praxis. Die Namen sind verändert.<br />
•	Unter dem Stichwort Aufgabe empfehlen wir Ihnen Ihre eigenen Gedanken zu dem Fallbeispiel zu Papier zu bringen, bevor Sie die Informationen lesen. <br />
•	Diskutieren Sie in der Familie, im Freundeskreis oder in der Gruppe der ehrenamtlichen Begleiterinnen die Beispiele – auch kontrovers! <br />
•	Unter Medien finden Sie Lektüreempfehlungen, Links zu Kurzfilmen oder anderem hilfreichen Material. <br />
•	Unter Tipps finden Sie Anregungen für den Umgang mit Menschen mit Demenz.<br />
•	Am Schluss des jeweiligen Moduls finden Sie Quizfragen, die Ihnen zur Ergebnissicherung dienen. <br />
<br /><br />
Wir wünschen Ihnen, dass Sie bei den Ihnen anvertrauten Menschen viele lichte Momente finden oder sie sogar auslösen können ... <br /><br />
</p>
</IonCardContent>
</IonCard>
      </IonContent>
    </IonPage>
  );
};

export default Infos;
